<ion-item lines="none">
  <ion-input (ionChange)="onInputEntered()" (keyup.enter)="addTask()" [(ngModel)]="taskTitle" [clearInput]="true" class="custom"/>
  <ion-button (click)="addTask()" [color]="buttonColor" size="default" slot="end">
    <ion-icon name="save-outline" slot="icon-only"/>
  </ion-button>
</ion-item>
